<template>
  <validation-observer ref="observer">
    <v-dialog v-model="dialog" max-width="350px">
      <v-card>
        <v-card-title class="text-h6">
          {{ title }}
        </v-card-title>

        <v-card-text>
          <v-container class="pa-0">
            <v-row class="pa-0">
              <v-col cols="12">
                <validation-provider v-slot="{ errors }" name="reason" rules="required">
                  <v-text-field v-model="note" label="Reason for removing inventory"
                    :error-messages="errors"></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="openDialog">
            cancel
          </v-btn>

          <v-btn color="green darken-1" text @click="onSubmit">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate"
export default {
  components: {
    ValidationObserver, ValidationProvider
  },
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialog: false,
      note: "",
    };
  },

  methods: {
    openDialog() {
      this.dialog = !this.dialog
    },
    async onSubmit() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.$emit("on-submit", this.note);
        this.note = "";
      }
    },
  },
};
</script>
